import MenuModal from './MenuModal';

export default {
  MenuModal,
};
